import { render } from "./SpacesManageMembersPopUp.vue?vue&type=template&id=6949ffa8&scoped=true&ts=true"
import script from "./SpacesManageMembersPopUp.vue?vue&type=script&lang=ts"
export * from "./SpacesManageMembersPopUp.vue?vue&type=script&lang=ts"

import "./SpacesManageMembersPopUp.vue?vue&type=style&index=0&id=6949ffa8&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6949ffa8"]])

export default __exports__